import { combineReducers, StateFromReducersMapObject } from "redux";
import auth from "./slices/auth";
import { globalReducer as global } from "./global/slice";
import { organizationReducer as organization } from "./organization/slice";
import { notistackReducer as notistack } from "./notistack/slice";
import { userReducer as user } from "./user/slice";

export const rootReducerObject = {
	auth,
	global,
	organization,
	notistack,
	user,
};

const rootReducer = combineReducers(rootReducerObject);

export type RootState = StateFromReducersMapObject<typeof rootReducerObject>;

export default rootReducer;
